import auth from './auth'
import club from './club'
import common from './common'
import constant from './constant'
import event from './event'
import home from './home'
import performance from './performance'
import player from './player'

import terms from './terms'
import user from './user'
import benefits from './benefits'
import coach from './coach'

const localization = {
  translation: {
    common,
    event,
    club,
    performance,
    player,
    user,
    home,
    terms,
    auth,
    constant,
    benefits,
    coach,
  },
}

export default localization
